export const SUPPORTED_VIEWER_FILE_TYPES = [
  'glTF', 'Autodesk FBX', 'OBJ', 'Stereolithography',
]

const matchesSupportedType = (title) => {
  if (!title) return false
  return SUPPORTED_VIEWER_FILE_TYPES.some(supported => title.startsWith(supported))
}

export const hasSupportedFileTypesForViewer = (files, fileTypes) => {
  const supportedTypeIds = fileTypes
    .filter(ft => matchesSupportedType(ft.title || ft.label))
    .map(ft => ft.id || ft.value)

  return files.some(file =>
    file.itemFileInfos?.some(info =>
      supportedTypeIds.includes(info.attributes?.fileTypeId || info.fileTypeId)
    )
  )
}
